import React, { useEffect, useState } from "react";
import Footer from "../Components/Footer";
import Navbar from "../Components/Navbar";
import FeatureSlider from "../Components/FeatureSlider";
import LmsSlider from "../Components/LmsSlider";
import Aos from "aos";
import { getLms } from "../Common/apis";
import Loader from "../Loader/Loader";

function LMS() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  console.log(data);

  useEffect(() => {
    Aos.init({
      duration: 1000, // animation duration in ms
      once: true // animate only once
    });
  }, []);

  useEffect(() => {
    const fetchServices = async () => {
      try {
        const res = await getLms();
        setData(res.data || []);
      } catch (err) {
        console.error("Error fetching services:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchServices();
  }, []);

  return (
    <>
      <div className="main-div2">
        <Navbar />
        {loading && <Loader />}
        <div className="grid xl:grid-cols-2 grid-cols-1 md:gap-0 gap-[20px] justify-between overflow-hidden items-start md:pt-[163px] pt-[100px]">
          <div>
            <div className="pt-[34px]">
              <img
                data-aos="fade-right"
                src="/assets/train/p5.svg"
                className="relative left-[-70px] md:h-[88px] h-[70px] max-w-[429px] w-full"
                alt=""
              />
            </div>
          </div>
          <div>
            <div
              data-aos="fade-left"
              className="md:mr-[104px] mr-0 mb-[60px] relative z-20 bg-[#6953A3] rounded-tr-[100px] rounded-bl-[100px] border-[8px] border-[#FDD60D] p-[30px]"
            >
              <h6 className="pt-[13px] font-sans font-[500] text-[31px] leading-[42px] text-[#FFFFFF] pb-[14px]">
                Welcome to GISUL – Practical Learning, Real Impact
              </h6>
              <p className="font-[400] pb-[81px] font-sans text-[16px] leading-[26px] text-[#FFFFFF]">
                GISUL is committed to shaping the future of professionals
                through industry-aligned, hands-on training modules. Designed
                for both aspiring learners and working professionals, GISUL’s
                programs focus on real-world applications, ensuring that every
                learner gains practical experience and job-ready skills. With
                tailored content, expert-led sessions, and a focus on continuous
                learning, GISUL stands as a trusted partner in your career
                growth journey.
              </p>
            </div>
            <div className="flex relative">
              <div className="bg-[#6953A3] z-10 absolute w-[9px] left-[270px] top-[-63px] h-[107px]"></div>
              <img
                src="/assets/train/h4.svg"
                className="absolute top-[37px] left-[75px]"
                alt=""
              />
              <button
                data-aos="fade-up"
                className="bg-[#FDD60D] rounded-full py-[16px] px-[72px] font-sans relative z-10 xl:ml-[131px] lg:ml-[130px] md:ml-[130px] ml-[40px] font-[500] text-[40px] leading-[46px] text-[#1D1837] tracking-[-0.32px]"
              >
                Features
              </button>
            </div>
            <div className="pt-[84px] pb-[150px] lms-slider">
              <div className="line"></div>
              <div className="relative z-10">
                <LmsSlider data={data} />
              </div>
            </div>
          </div>
        </div>
        {/*             
               <div className="New-login">
                       <div className="New-login-left">
                         <div className="b1">
                           <h2>Have Your Own</h2>
                         </div>
                         <br />
                    
                       
                    
                       </div>
                   
               
                       <div className="New-login-right">
                 
                       <div className="LateralHirning-box LateralHirning-box2">
                       <h3>Welcome to edForce Hands-On Labs</h3>
                       <p>edForce a Leading Workforce Upskilling Accelerator has been helping organizations of all stratus with seamless training Modules. The lateral training program is an exercise that designs custom-made courses for the existing Employees of the organization.
                       With Lateral Training Modules,</p>
            
                    
                       </div>
                       <br/>
                       <br/>
            <button className='Features'>Features</button>
            <br/>
            <br/>

            <div className='Features-circle-div'>
            <div>

            <div className='Features-circle-card2'>
            <p>Playground Labs</p>
            </div>
                       </div>

                       <div>

<div className='Features-circle-card2'>
<p>Playground Labs</p>
</div>
           </div>
           <div>

<div className='Features-circle-card2'>
<p>Playground Labs</p>
</div>
           </div>
           <div>

<div className='Features-circle-card2'>
<p>Playground Labs</p>
</div>
           </div>

                       </div>
                       </div>
                     </div>
            <br/>
            <br/> */}

        <Footer />
      </div>
    </>
  );
}

export default LMS;
